// removed by extract-text-webpack-plugin
module.exports = {"ModalOverlay":"ModalOverlay---1BGo-","ModalOverlay--light":"ModalOverlay--light---3c6gD","ModalOverlay--dark":"ModalOverlay--dark---3izeh","ModalContent":"ModalContent---2nR4X","CloseButton":"CloseButton---39u9N"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/Modal/style.styl
// module id = ley4
// module chunks = 88